import React from 'react';
import classnames from 'classnames';

const FilterLayout = ({ textHeader, children, open = true }) => {
    return (
        <section className={classnames('uk-card-body', { 'uk-open': open }, 'aps-filter-layout')}>
            <h4 className="uk-accordion-title uk-margin-remove aps-filter-layout-heading">{textHeader}</h4>
            <div className="uk-accordion-content" aria-hidden={!open} hidden={!open}>
                {children}
            </div>
        </section>
    );
};

export default FilterLayout;
